import React, { useState } from 'react';
import PortalGlobalReservas from './GlobalComponentes/PortalGlobalReservas';
import PortalGlobalNotificaciones from './GlobalComponentes/PortalGlobalNotificaciones';
import PortalGlobalPagos from './GlobalComponentes/PortalGlobalPagos'; // 👈 Importamos el nuevo componente de pagos

export default function PortalGlobal() {
  const [moduloActivo, setModuloActivo] = useState('hub'); // 'hub', 'reservas', 'notificaciones' o 'pagos'

  return (
    <div style={{ backgroundColor: '#f8fafc', minHeight: '100vh', padding: '20px', borderRadius: '12px' }}>
      
      {/* Barra superior de navegación interna */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: 'white', padding: '15px 25px', borderRadius: '10px', border: '1px solid #e2e8f0', marginBottom: '20px', flexWrap: 'wrap', gap: '15px' }}>
        <div>
          <h2 style={{ margin: 0, color: '#1e293b' }}>🏢 MMD&L - Panel Global</h2>
          <p style={{ margin: '3px 0 0 0', fontSize: '0.8rem', color: '#64748b' }}>Sesión activa: <strong>globalmmdl</strong></p>
        </div>

        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          {/* Botón para volver al Hub si estás dentro de un módulo */}
          {moduloActivo !== 'hub' && (
            <button 
              onClick={() => setModuloActivo('hub')}
              style={{ backgroundColor: '#64748b', color: 'white', border: 'none', padding: '8px 14px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', fontSize: '0.85rem' }}
            >
              ← Volver al Hub
            </button>
          )}
        </div>
      </div>

      {/* Renderizado condicional: Muestra el Hub o el módulo seleccionado */}
      {moduloActivo === 'hub' ? (
        <div>
          <div style={{ marginBottom: '20px', textAlign: 'left' }}>
            <h3 style={{ color: '#1e293b', marginBottom: '5px' }}>🎯 Hub de Administración Global</h3>
            <p style={{ color: '#64748b', fontSize: '0.9rem', margin: 0 }}>Selecciona una herramienta para supervisar la gestión de los edificios.</p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '20px' }}>
            
            {/* Tarjeta 1: Reservas Globales */}
            <div 
              onClick={() => setModuloActivo('reservas')}
              style={{ backgroundColor: 'white', border: '1px solid #cbd5e1', borderRadius: '12px', padding: '25px', cursor: 'pointer', boxShadow: '0 4px 6px rgba(0,0,0,0.02)', textAlign: 'left' }}
            >
              <div style={{ fontSize: '2.5rem', marginBottom: '10px' }}>📅</div>
              <h4 style={{ margin: '0 0 8px 0', color: '#1e293b', fontSize: '1.1rem' }}>Reservas Globales</h4>
              <p style={{ color: '#64748b', fontSize: '0.85rem', margin: '0 0 15px 0' }}>Supervisa y consulta las reservas de áreas sociales de todos los edificios.</p>
              <span style={{ display: 'inline-block', backgroundColor: '#e0f2fe', color: '#0369a1', padding: '6px 12px', borderRadius: '20px', fontSize: '0.8rem', fontWeight: 'bold' }}>Ingresar →</span>
            </div>

            {/* Tarjeta 2: Notificaciones Globales */}
            <div 
              onClick={() => setModuloActivo('notificaciones')}
              style={{ backgroundColor: 'white', border: '1px solid #cbd5e1', borderRadius: '12px', padding: '25px', cursor: 'pointer', boxShadow: '0 4px 6px rgba(0,0,0,0.02)', textAlign: 'left' }}
            >
              <div style={{ fontSize: '2.5rem', marginBottom: '10px' }}>📢</div>
              <h4 style={{ margin: '0 0 8px 0', color: '#1e293b', fontSize: '1.1rem' }}>Enviar Notificaciones</h4>
              <p style={{ color: '#64748b', fontSize: '0.85rem', margin: '0 0 15px 0' }}>Envía comunicados y alertas a los portales de los propietarios por edificio o de forma masiva.</p>
              <span style={{ display: 'inline-block', backgroundColor: '#e0f2fe', color: '#0369a1', padding: '6px 12px', borderRadius: '20px', fontSize: '0.8rem', fontWeight: 'bold' }}>Ingresar →</span>
            </div>

            {/* Tarjeta 3: Auditoría de Pagos por Edificio */}
            <div 
              onClick={() => setModuloActivo('pagos')}
              style={{ backgroundColor: 'white', border: '1px solid #cbd5e1', borderRadius: '12px', padding: '25px', cursor: 'pointer', boxShadow: '0 4px 6px rgba(0,0,0,0.02)', textAlign: 'left' }}
            >
              <div style={{ fontSize: '2.5rem', marginBottom: '10px' }}>💰</div>
              <h4 style={{ margin: '0 0 8px 0', color: '#1e293b', fontSize: '1.1rem' }}>Auditoría de Pagos</h4>
              <p style={{ color: '#64748b', fontSize: '0.85rem', margin: '0 0 15px 0' }}>Revisa el estado de los pagos y vouchers subidos por los propietarios en cada edificio.</p>
              <span style={{ display: 'inline-block', backgroundColor: '#e0f2fe', color: '#0369a1', padding: '6px 12px', borderRadius: '20px', fontSize: '0.8rem', fontWeight: 'bold' }}>Ingresar →</span>
            </div>

          </div>
        </div>
      ) : moduloActivo === 'reservas' ? (
        <PortalGlobalReservas />
      ) : moduloActivo === 'notificaciones' ? (
        <PortalGlobalNotificaciones />
      ) : moduloActivo === 'pagos' ? (
        <PortalGlobalPagos />
      ) : null}
      
    </div>
  );
}